export default "__VITE_ASSET__CyILnjy5__"